// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PySV","top":"styles_top__28Fu6","left":"styles_left__QwGVD","description":"styles_description__15gw6"};